// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  overflow: hidden;
  height: 100%;
  background-color: var(--body-background);
  margin: 0;
  padding: 0;
}

/* .corpo {
    display: grid;
    grid-template-columns: 1fr 1fr 3fr;
    grid-template-rows: 12vh auto;
    min-height: 100vh;
}

.menu-superior {
    grid-column: 1 / span 3;
    grid-row: 1 / 2;
    background-color: gray;
}

.menu-lateral {
    grid-column: 1 / 2;
    grid-row: 2 / span 2;
    background-color: lightgray;
}

.conteudo {
    grid-column: 2 / span 3;
    grid-row: 2 / span 2;
    background-color: var(--body-background);
    overflow-y: auto;
    max-height: calc(100vh - 12vh);
}

.informacoes {
    width: 100%;
    height: 30vh;
    background-color: var(--body-background);
    border-top: 2px solid var(--grey-shadow);
    border-bottom: 2px solid var(--grey-shadow);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
}

.evento {
    flex-basis: 50%;
}

.botoes {
    display: flex;
    gap: 10px;
}

.evento-header {
    color: var(--blue);
    font-weight: bold;
    margin-bottom: 2vh;
}

.evento-nome {
    font-weight: bold;
}

.evento-detalhe {
    color: var(--grey);
}

.cards-group {
    flex-basis: calc(25% - 10px);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.card-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

.card {
    margin: 10px;
    margin-top: 10px;
}

.card-footer {
    background-color: var(--grey-shadow) !important;
}

.card-header {
    background-color: lightblue !important;
    font-weight: bold;
} */`, "",{"version":3,"sources":["webpack://./src/views/Home/home.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,wCAAwC;EACxC,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAuFG","sourcesContent":["html,\nbody {\n  overflow: hidden;\n  height: 100%;\n  background-color: var(--body-background);\n  margin: 0;\n  padding: 0;\n}\n\n/* .corpo {\n    display: grid;\n    grid-template-columns: 1fr 1fr 3fr;\n    grid-template-rows: 12vh auto;\n    min-height: 100vh;\n}\n\n.menu-superior {\n    grid-column: 1 / span 3;\n    grid-row: 1 / 2;\n    background-color: gray;\n}\n\n.menu-lateral {\n    grid-column: 1 / 2;\n    grid-row: 2 / span 2;\n    background-color: lightgray;\n}\n\n.conteudo {\n    grid-column: 2 / span 3;\n    grid-row: 2 / span 2;\n    background-color: var(--body-background);\n    overflow-y: auto;\n    max-height: calc(100vh - 12vh);\n}\n\n.informacoes {\n    width: 100%;\n    height: 30vh;\n    background-color: var(--body-background);\n    border-top: 2px solid var(--grey-shadow);\n    border-bottom: 2px solid var(--grey-shadow);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 10px;\n}\n\n.evento {\n    flex-basis: 50%;\n}\n\n.botoes {\n    display: flex;\n    gap: 10px;\n}\n\n.evento-header {\n    color: var(--blue);\n    font-weight: bold;\n    margin-bottom: 2vh;\n}\n\n.evento-nome {\n    font-weight: bold;\n}\n\n.evento-detalhe {\n    color: var(--grey);\n}\n\n.cards-group {\n    flex-basis: calc(25% - 10px);\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.card-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n.card {\n    margin: 10px;\n    margin-top: 10px;\n}\n\n.card-footer {\n    background-color: var(--grey-shadow) !important;\n}\n\n.card-header {\n    background-color: lightblue !important;\n    font-weight: bold;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
